import { OctagonX } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { CredentialFailureKind } from './types';
import { integrationStatusCopy as copy } from './status/copy';

interface Props {
  vendorName: string;
  kind: CredentialFailureKind;
}

/**
 * Inline "Connection failed" alert shown above the credentials form after a
 * failed save-time credential test (spec §5.6). Replaces the old error toast.
 * Mirrors `DisabledIntegrationBanner`'s destructive alert (direct `svg` +
 * `AlertTitle` + `AlertDescription` children so the `Alert` primitive's own
 * icon-offset CSS applies without a wrapper div).
 */
export const ConnectionFailedAlert = ({ vendorName, kind }: Props) => (
  <Alert variant="destructive" role="alert" className="mb-5 rounded-xl">
    <OctagonX className="h-4 w-4" aria-hidden="true" />
    <AlertTitle>{copy.editMode.failedTitle}</AlertTitle>
    <AlertDescription>
      {kind === 'first' ? copy.editMode.failedFirst(vendorName) : copy.editMode.failedUpdate}
    </AlertDescription>
  </Alert>
);
